import { types } from 'mobx-state-tree';

import mandatoryId from 'utils/store/mandatoryId';

export const UserFireConfigModel = types.model('UserFireConfigModel', {
  id: types.identifierNumber,
  target_group: types.maybe(types.string),
  service: types.maybe(types.string),
  business_target: types.maybe(types.string),
  selected_region: types.maybe(types.string),
  selected_industry: types.maybe(types.string),
  amount_of_benchmarks_per_painpoint: types.maybe(types.number),
  flavor_id: types.maybe(types.number)
});

export const createUserFireConfigModel = (
  data?: any
): UserFireConfigModelType | undefined => {
  if (!data) {
    return undefined;
  }

  return UserFireConfigModel.create({
    id: mandatoryId(data?.id),
    target_group: data?.target_group || undefined,
    service: data?.service || undefined,
    business_target: data?.business_target || undefined,
    selected_region: data?.selected_region || undefined,
    selected_industry: data?.selected_industry || undefined,
    amount_of_benchmarks_per_painpoint:
      data?.amount_of_benchmarks_per_painpoint || undefined,
    flavor_id: data?.flavor_id || undefined
  });
};

export type UserFireConfigModelType = typeof UserFireConfigModel.Type;
export default UserFireConfigModel;
